import React, { useState } from 'react'
import { connect } from 'react-redux'
import {
  updateMonsterSearch,
  clearMonsterSearch,
} from '../../actions'

import './MonsterSearch.css'

const MonsterSearch = (props) => {
  const {
    label,
    onSelectMonster,
    query,
    searchResults,
  } = props

  const [selectedIndex, setSelectedIndex] = useState(-1)

  const handleQueryChange = e => {
    setSelectedIndex(-1)
    props.updateMonsterSearch(e.target.value)
  }

  const handleMonsterSelect = suggestion => {
    setSelectedIndex(-1)
    props.clearMonsterSearch()
    onSelectMonster(suggestion)
  }

  const handleKeyDown = e => {
    if (searchResults.length === 0) return

    if (e.key === 'ArrowDown') {
      e.preventDefault()
      setSelectedIndex(i => Math.min(i + 1, searchResults.length - 1))
    } else if (e.key === 'ArrowUp') {
      e.preventDefault()
      setSelectedIndex(i => Math.max(i - 1, 0))
    } else if (e.key === 'Enter' && selectedIndex >= 0) {
      e.preventDefault()
      handleMonsterSelect(searchResults[selectedIndex])
    } else if (e.key === 'Escape') {
      props.clearMonsterSearch()
      setSelectedIndex(-1)
    }
  }

  return (
    <div className='MonsterSearch'>
        <label>{label}</label>
        <input
          type='text'
          value={query}
          onChange={handleQueryChange}
          onKeyDown={handleKeyDown}
        />

        <div className='MonsterSearch__results'>
          {searchResults.map((suggestion, index) => {
            const selectFn = handleMonsterSelect.bind(null, suggestion)
            const className = 'MonsterSearch__result' +
              (index === selectedIndex ? ' MonsterSearch__result--selected' : '')
            return (
              <div
                key={suggestion.game_id}
                className={className}
                onClick={selectFn}
              >
                {suggestion.name}
                {suggestion.level != null && (
                  <span className='MonsterSearch__level'> (Lvl {suggestion.level})</span>
                )}
              </div>
            )
          })}
        </div>
    </div>
  )
}

const mapStateToProps = state => {
  return {
    searchResults: state.monsters.searchResults,
    query: state.monsters.query,
  }
}

const mapDispatchToProps = {
  updateMonsterSearch,
  clearMonsterSearch,
}

export default connect(mapStateToProps, mapDispatchToProps)(MonsterSearch)
